module.exports = __webpack_public_path__ + "static/media/store-publix.8b17b5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/store-publix.jpg
// module id = 216
// module chunks = 0